import { post } from './http'

//获取场馆列表
export function getVenueList() {
  return post('/tyapi/pc/venue/getVenueList', {})
}
//获取场地价格
export function getVenuePrice() {
  return post('/tyapi/pc/venue/getVenuePrice', {})
}

//获取场地详情
export function getVenueInfo(venueId) {
  return post('/tyapi/pc/venue/getVenueInfo', {
    venueId: venueId,
  })
}
